import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, includes, isEmpty, map } from 'lodash';
import { Form, Col } from 'react-bootstrap';

import { LAYER_SUBTYPES, GEOREF_TYPES, FIWARE_VERSIONS } from '../../../api/Layers/Layers';
import * as layerOps from '../../../api/Layers/layer-operations';

import LoadButton from '../LoadButton';

const LayerFiwareFields = ({
  fiwareLayerName,
  fiwareLayers,
  fiwareVersion,
  geojsonLoading,
  layer,
  layerSubType,
  thematicKeyList,
  loadFiware,
  loadFiwareAttributes,
  loadFiwareLayers
}) => {
  const thematicListToUse = isEmpty(thematicKeyList)
    ? map(layerOps.getGeoJSONProps(layer), 'name')
    : thematicKeyList;

  const [fiwareLoading, changeFiwareLoading] = useState(false);

  const [attributesLoading, changeAttributesLoading] = useState(false);

  const possibleGeorefTypes = cloneDeep(GEOREF_TYPES.properties);
  delete possibleGeorefTypes.H3;
  if (!includes(thematicListToUse, GEOREF_TYPES.LOCATION)) delete possibleGeorefTypes.LOCATION;
  if (!includes(thematicListToUse, GEOREF_TYPES.ADDRESS)) delete possibleGeorefTypes.ADDRESS;

  const handleFiwareLayersLoad = async event => {
    changeFiwareLoading(true);
    await loadFiwareLayers(event);
    changeFiwareLoading(false);
  };

  const selectFiwareLayer = async event => {
    changeAttributesLoading(true);
    await loadFiwareAttributes(event);
    changeAttributesLoading(false);
  };

  if (
    LAYER_SUBTYPES.FIWARE !== layerSubType ||
    !includes([FIWARE_VERSIONS.V1, FIWARE_VERSIONS.V3], fiwareVersion)
  )
    return '';
  return (
    <>
      <Form.Row>
        {fiwareVersion === FIWARE_VERSIONS.V1 && (
          <>
            <Form.Group as={Col} xs={6}>
              <Form.Label>Application ID</Form.Label>
              <Form.Control
                type="text"
                name="fiwareApplicationID"
                defaultValue={layerOps.getFiwareApplicationID(layer)}
              />
            </Form.Group>
            <Form.Group as={Col} xs={6}>
              <Form.Label>Application Secret</Form.Label>
              <Form.Control
                type="text"
                name="fiwareApplicationSecret"
                defaultValue={layerOps.getFiwareApplicationSecret(layer)}
              />
            </Form.Group>
          </>
        )}
        <Form.Group as={Col} xs={6}>
          <Form.Label>IP Address</Form.Label>
          <Form.Control type="text" name="host" defaultValue={layerOps.getFiwareHost(layer)} />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Port</Form.Label>
          <Form.Control type="number" name="port" defaultValue={layerOps.getFiwarePort(layer)} />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>User</Form.Label>
          <Form.Control type="text" name="user" defaultValue={layerOps.getFiwareUser(layer)} />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            name="password"
            defaultValue={layerOps.getFiwarePassword(layer)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Service</Form.Label>
          <Form.Control
            type="text"
            name="service"
            defaultValue={layerOps.getFiwareService(layer)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Subservice</Form.Label>
          <Form.Control
            type="text"
            name="subservice"
            defaultValue={layerOps.getFiwareSubservice(layer)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Context Broker URL</Form.Label>
          <Form.Control type="text" name="fiwareURL" defaultValue={layerOps.getFiwareURL(layer)} />
        </Form.Group>
        <Form.Group as={Col} xs={6} className="pt-3 mt-3">
          <LoadButton isLoading={fiwareLoading} clickAction={handleFiwareLayersLoad} />
        </Form.Group>
      </Form.Row>
      {!isEmpty(fiwareLayers) && (
        <Form.Row>
          <Form.Group as={Col} xs={8}>
            <Form.Label>Layers</Form.Label>
            <Form.Control
              as="select"
              name="fiwareLayerName"
              value={fiwareLayerName}
              onChange={selectFiwareLayer}
            >
              <option value="">-</option>
              {map(fiwareLayers, fiwareLayer => {
                return (
                  <option value={fiwareLayer} key={fiwareLayer}>
                    {fiwareLayer}
                  </option>
                );
              })}
            </Form.Control>
          </Form.Group>
          <Form.Group as={Col} xs={4} className="pt-3 mt-3">
            <LoadButton
              disabled={isEmpty(fiwareLayerName)}
              isLoading={geojsonLoading || attributesLoading}
              clickAction={loadFiware}
            />
          </Form.Group>
        </Form.Row>
      )}
    </>
  );
};

LayerFiwareFields.propTypes = {
  fiwareLayerName: PropTypes.string.isRequired,
  fiwareLayers: PropTypes.array.isRequired,
  fiwareVersion: PropTypes.string.isRequired,
  geojsonLoading: PropTypes.bool.isRequired,
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  thematicKeyList: PropTypes.array.isRequired,
  loadFiware: PropTypes.func.isRequired,
  loadFiwareAttributes: PropTypes.func.isRequired,
  loadFiwareLayers: PropTypes.func.isRequired
};

export default LayerFiwareFields;
